export default "__VITE_ASSET__BPnw$ZOS__"